import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface SpeciesProps {
  labels: {
    header: string;
    species: string;
  };
  data: {
    species: string | null | undefined;
  };
}

const Species = ({ labels, data }: SpeciesProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.species !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.species} data={data.species} />
      </View>
    </>}
  </>
);

export default Species;